var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-box"},[_c('div',{staticClass:"caption sl-secondary-text nowrap"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"subtitle-2 detail-box",class:_vm.color},[_vm._v(_vm._s(_vm.detail))])])
}
var staticRenderFns = []

export { render, staticRenderFns }